import React from "react"
import ReactDOM from "react-dom"
import Card from './VacanciesFilter/components/Card'
//import App from "./App"
//import DataWrapper from "../DataWrapper"
//import Translations from "../TranslationsWrapper"
//import FavouritesWrapper from "../FavouritesWrapper"
// import { configureUrlQuery } from "react-url-query"
// import { compose } from "recompose"
import { Provider } from "rebass"

// import history from "./history"
import theme from "./theme"

// configureUrlQuery({ history })

// init
const cards =  document.querySelectorAll('.js-vacancy-card')

cards.forEach((element) => {
  const data = element.dataset
  ReactDOM.render(
		<Provider theme={theme}>
			<Card
        simple
				title={data.vacancyTitle}
				disciplines={[data.vacancyDisciplines]}
				educationLevels={[data.vacancyEducation]}
				location={data.vacancyLocation}
				url={data.vacancyUrl}
			/>
		</Provider>,
		element
	)
})
